import React, {useEffect, useState} from 'react'
import {useQuery} from 'react-query';
import {useTranslation} from 'react-i18next';
import {Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { redirecturl } from '../../services/common/redirect'
import NojoomEarnPointsShimmer from '../../ShimmerEffect/NojoomEarnPoints-shimmer';
function NojoomEarnPoints({pmsitem}) {
    const {t} = useTranslation();
    const [dataList, setDataList] = useState([])
    const navigate = useNavigate()
    const { data: { data } = {}, isLoading , isFetching,
    isSuccess
    } = useQuery(
        ['', pmsitem?.method, JSON.parse(pmsitem?.sourceid), {}],
        {
          retry: false,
          retryOnMount: false
        }
      );
      useEffect(()=>{
        if(isSuccess){
            let [temp] = data?.response?.dynamictypes?.map(item => item?.cards);
            setDataList(temp);
        }
      }, [isSuccess])

    const redirect =(url)=>{
      redirecturl(url,navigate);
      return false;
    }



      return (
    <>
      {(isLoading || isFetching ) && <div>
        <NojoomEarnPointsShimmer/>
      </div>}
    <div class="dls-sprint13-comp pt-4 pse_sm mb-5">
    <div class="flex_grp_between mb-3">
        <h3 class="section_title_light mb-0">{data?.response?.dynamictypes[0]?.heading}</h3>
    </div>
    {dataList?.length > 0 &&
        <Swiper
            className="sprint14-earn-points gap-2"
            spaceBetween={12}
            pagination={false}
            slidesPerView={dataList?.length > 1 ? 2 : 1}
            grid={{ rows: 1, fill: "row" }}
        >
        {dataList?.slice(0,4)?.map((item) => {
            return (
            <SwiperSlide className='sprint14-colm'>
                 {/* <div className="img-sec d-flex" onClick={()=> navigate('/nojoom-buypoints')}>
                      <div>
                        <h2 className="mb-0">{item?.displaytext}</h2>
                        <div className=" primary_color primary-font mt-3">
                          <span>
                            {item?.buttontext} 
                          </span>
                          <span className="ms-1">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/right_arrow_red.svg"
                              }
                              class="img-w16"
                              alt=""
                              title=""
                            />
                          </span>
                        </div>
                      </div>
                      <div className="imgcomp">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/star-bg-2x.png"
                          }
                          alt=""
                          title=""
                        />
                      </div>
                    </div> */}
                     
                     <div onClick={()=>redirect(item?.redirecturl)}>
                                        <label>{item?.displaytext}</label>
                                        <div class="hyperlink-text d-flex justify-content-end">
                                            <a class="hyperlink">{item?.buttontext} 
                                            <img src={
                                process.env.PUBLIC_URL +
                                "/assets/images/right_arrow_red.svg"
                              } class="ms-1" alt=""></img> </a>
                                        </div>
                                        <div class="imgcomp">
                                            <img  src={
                            process.env.PUBLIC_URL +
                            "/assets/images/star-bg-2x.png"
                          } alt="" title="" />
                                        </div>
                                    </div>
                    
                   


            </SwiperSlide>
            );
        })}
        </Swiper>
    }
</div>
</>
 
  )
}

export default NojoomEarnPoints
